import React from "react";
import PropTypes from "prop-types";

export function SLSvgElectronicDelivery({ selected = false }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="100" height="80">
      <defs></defs>
      <g id="Layer_1" data-name="Layer 1" />
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <g>
            <path
              fill={selected === false ? "#727272" : "#21409a"}
              d="M94.66,26.51c-2.84-2.4-7.08-2.06-9.49,.78l-10.44,12.04c-1.12-2.05-3.28-3.42-5.75-3.42H32.88c-3.33,0-6.52,1.32-8.87,3.67l-4.85,4.85s-.01,0-.02,.01l-9.48,9.48c-.52,.52-.52,1.36,0,1.88l19.55,19.55c.25,.25,.58,.39,.93,.39,.35,0,.69-.14,.93-.39l9.48-9.48s0-.02,.02-.02l3.48-3.48c1.85-1.86,4.37-2.91,6.99-2.9h18.18c1.83,0,3.64-.42,5.29-1.2,1.64-.77,3.11-1.85,4.34-3.17h.01s.01-.03,.02-.03l16.43-18.94s.07-.08,.1-.12c2.4-2.84,2.06-7.09-.78-9.49ZM20.08,47.26l17.67,17.67-7.6,7.6L12.48,54.86l7.6-7.6Zm52.78-5.13c.01,.11,.02,.22,.02,.33,0,2.16-1.75,3.9-3.91,3.91h-19.29s-.05,0-.07,0c-.73,.02-1.31,.63-1.29,1.36s.63,1.31,1.36,1.29h19.29c3.62,0,6.56-2.93,6.57-6.55v-.02l11.64-13.41c1.47-1.66,4.01-1.84,5.7-.41,1.72,1.46,1.93,4.04,.47,5.76l-16.43,18.92c-1.97,2.17-4.75,3.44-7.68,3.52h-18.18c-3.33,0-6.52,1.32-8.87,3.67l-2.56,2.56-17.67-17.67,3.92-3.92c1.85-1.86,4.37-2.91,6.99-2.9h36.1c2,0,3.67,1.51,3.87,3.5,0,.01,0,.02,0,.03,0,.02,.01,.03,.01,.04Z"
            />
            <path
              fill={selected === false ? "#727272" : "#21409a"}
              d="M53.13,9.55c-2.83,0-5.13,2.3-5.13,5.13,0,2.83,2.3,5.13,5.13,5.13,2.83,0,5.12-2.3,5.13-5.13,0-2.83-2.3-5.13-5.13-5.13Zm0,2.65h0c1.37,0,2.48,1.11,2.48,2.48s-1.11,2.48-2.48,2.48-2.48-1.11-2.48-2.48c0-1.37,1.11-2.48,2.48-2.48Z"
            />
            <path
              fill={selected === false ? "#727272" : "#21409a"}
              d="M64.03,13c-.92,0-1.67,.75-1.67,1.67,0,.92,.75,1.67,1.67,1.67s1.67-.75,1.67-1.67-.75-1.67-1.67-1.67Z"
            />
            <path
              fill={selected === false ? "#727272" : "#21409a"}
              d="M42.24,13c-.92,0-1.67,.75-1.67,1.67,0,.92,.75,1.67,1.67,1.67s1.67-.75,1.67-1.67-.75-1.67-1.67-1.67Z"
            />
            <path
              fill={selected === false ? "#727272" : "#21409a"}
              d="M28.74,29.35h48.8c.73,0,1.33-.6,1.32-1.33V1.33c0-.73-.59-1.32-1.32-1.33H28.74c-.73,0-1.33,.59-1.33,1.33V28.02c0,.73,.59,1.33,1.33,1.33Zm1.32-2.65V2.65h46.15V26.7H30.06Z"
            />
            <path
              fill={selected === false ? "#727272" : "#21409a"}
              d="M71.39,8.27c-1.2,0-2.17-.97-2.17-2.17,0-.73-.59-1.33-1.33-1.33h-29.37c-.73,0-1.33,.59-1.33,1.33,0,1.2-.97,2.17-2.17,2.17h-.09s-.05,0-.08,0c-.73,0-1.32,.59-1.31,1.32v10.17c0,.73,.59,1.33,1.33,1.33,1.2,0,2.17,.97,2.17,2.17,0,.73,.59,1.33,1.33,1.33h29.54c.73,0,1.31-.6,1.31-1.33,0-1.2,.97-2.17,2.17-2.17,.73,0,1.33-.59,1.33-1.33V9.59c0-.73-.59-1.33-1.33-1.33Zm-1.32,2.46v7.89c-1.6,.46-2.85,1.71-3.31,3.31h-27.25c-.46-1.6-1.71-2.85-3.31-3.31v-7.85c1.67-.42,2.99-1.7,3.46-3.35h27.1c.46,1.6,1.71,2.85,3.31,3.31Z"
            />
            <path
              fill={selected === false ? "#727272" : "#21409a"}
              d="M6.5,2.99l15.43,5.01h.02c.55,.18,1.14-.13,1.32-.68v-.02c.18-.55-.13-1.14-.68-1.32L7.16,.97h-.02c-.55-.18-1.14,.13-1.32,.68v.02c-.18,.55,.13,1.14,.68,1.32Z"
            />
            <path
              fill={selected === false ? "#727272" : "#21409a"}
              d="M23.27,22.2v-.02c-.18-.55-.77-.86-1.33-.69h-.02l-15.43,5.02c-.55,.17-.86,.76-.69,1.32v.02c.18,.55,.77,.86,1.33,.69h.02l15.43-5.02c.55-.17,.86-.76,.69-1.32Z"
            />
            <path
              fill={selected === false ? "#727272" : "#21409a"}
              d="M23.62,14.76s0-.01,0-.02c0-.58-.46-1.06-1.04-1.06,0,0-.01,0-.02,0H1.06C.48,13.67,0,14.13,0,14.72c0,0,0,.01,0,.02,0,.58,.46,1.06,1.04,1.06,0,0,.01,0,.02,0H22.56c.58,0,1.06-.46,1.06-1.04Z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}
SLSvgElectronicDelivery.propTypes = {
  selected: PropTypes.bool,
};

export function SLSvgInStorePickup({ selected = false }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="100" height="80">
      <defs></defs>
      <g id="Layer_1" data-name="Layer 1" />
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <g>
            <path
              fill={selected === false ? "#727272" : "#21409a"}
              d="M42.65,62.39h33.83c.77,0,1.39-.62,1.39-1.39v-23.13s0-.02,0-.03c0-.76-.63-1.37-1.39-1.36H42.65s-.02,0-.03,0c-.76,0-1.37,.63-1.36,1.39v23.13s0,.02,0,.03c0,.76,.63,1.37,1.39,1.36Zm18.3-23.13h14.14v20.35h-14.14v-20.35Zm-2.78,20.35h-14.12v-20.35h14.12v20.35Z"
            />
            <path
              fill={selected === false ? "#727272" : "#21409a"}
              d="M90.28,23.34c.04-.22,.04-.45-.03-.67L83.64,.98h0C83.45,.39,82.91,0,82.31,0H8c-.61,0-1.16,.39-1.34,.98L.13,22.48C.05,22.66,0,22.86,0,23.07c0,3.57,2.73,6.5,6.21,6.83v45.86s0,.02,0,.03c0,.76,.63,1.37,1.39,1.36H82.71c.38,0,.73-.15,1-.42,.25-.26,.39-.61,.38-.98V29.91c3.4-.32,6.06-3.12,6.19-6.56Zm-9.37,2.92c-.58-.47-1.03-1.09-1.29-1.79h7.66c-.26,.7-.7,1.32-1.29,1.79-1.48,1.2-3.6,1.2-5.09,0ZM17.21,44.39h17.82v29.99H17.21v-29.99Zm19.22-2.78H15.82s-.02,0-.03,0c-.76,0-1.37,.63-1.36,1.39v31.38h-5.43V29.6c1.35-.44,2.51-1.29,3.35-2.4,1.25,1.66,3.23,2.74,5.47,2.74,2.24,0,4.22-1.08,5.47-2.74,1.25,1.66,3.23,2.74,5.47,2.74,2.23-.01,4.2-1.08,5.46-2.73,1.25,1.66,3.23,2.73,5.47,2.73,2.24,0,4.22-1.08,5.47-2.74,1.25,1.66,3.23,2.74,5.47,2.74,2.23,0,4.21-1.07,5.46-2.73,1.25,1.65,3.23,2.72,5.46,2.73,2.24,0,4.22-1.08,5.47-2.74,1.25,1.66,3.23,2.74,5.47,2.74,2.24,0,4.22-1.08,5.47-2.74,.83,1.1,1.99,1.95,3.33,2.39v44.79H37.82v-31.38s0-.02,0-.03c0-.76-.63-1.37-1.39-1.36ZM83.49,10l1.36,4.46H5.48l1.36-4.46H83.49Zm2.22,7.24l1.36,4.44H3.28l1.35-4.44H85.7ZM21.64,24.46c-.26,.7-.7,1.32-1.29,1.79-1.48,1.2-3.6,1.2-5.09,0-.58-.47-1.03-1.09-1.29-1.79h7.66Zm10.95,0c-.26,.7-.7,1.32-1.29,1.79-1.48,1.2-3.6,1.2-5.08,0-.58-.47-1.03-1.09-1.29-1.79h7.66Zm10.93,0c-.26,.7-.7,1.32-1.29,1.79-1.48,1.2-3.6,1.2-5.08,0-.58-.47-1.03-1.09-1.29-1.79h7.66Zm10.95,0c-.26,.7-.7,1.32-1.29,1.79-1.48,1.2-3.6,1.2-5.09,0-.58-.47-1.03-1.09-1.29-1.79h7.66Zm10.93,0c-.26,.7-.7,1.32-1.29,1.79-1.48,1.2-3.6,1.2-5.08,0-.58-.47-1.03-1.09-1.29-1.79h7.66Zm10.95,0c-.26,.7-.7,1.32-1.29,1.79-1.48,1.2-3.6,1.2-5.08,0-.58-.47-1.03-1.09-1.29-1.79h7.66ZM7.68,7.22l1.35-4.44H81.28l1.36,4.44H7.68Zm3.01,17.25c-.26,.7-.7,1.32-1.29,1.79-1.48,1.2-3.6,1.2-5.09,0-.58-.47-1.03-1.09-1.29-1.79h7.66Z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}
SLSvgInStorePickup.propTypes = {
  selected: PropTypes.bool,
};

export function SLSvgEmail({
  height = "125px"
}) {
  return (
    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 199 219" height={height}>
      <defs>
        <style>
          {
            ".SLSvgEmail-1{fill:none;stroke-width:3px;} .SLSvgEmail-1,.SLSvgEmail-2{stroke:#1e4497;stroke-miterlimit:10;} .SLSvgEmail-2{fill:#1e4497;stroke-width:.15px;} .SLSvgEmail-3{fill:#fff;}"
          }
        </style>
      </defs>
      <g>
        <rect class="SLSvgEmail-1" x="45.96" y="68.22" width="103.47" height="70.83" />
        <line class="SLSvgEmail-1" x1="45.35" y1="68.22" x2="98.31" y2="103.94" />
        <line class="SLSvgEmail-1" x1="96.92" y1="104.15" x2="149.59" y2="68" />
      </g>
      <rect class="SLSvgEmail-3" x="95.23" y="107.02" width="46.19" height="46.98" />
      <path
        class="SLSvgEmail-2"
        d="M126.04,144.7c-3.06,1.72-6.3,2.29-9.93,2.29-9.17,0-17-6.69-17-17.57,0-11.65,8.02-21.58,20.44-21.58,9.74,0,16.24,6.88,16.24,16.24,0,8.4-4.78,13.37-9.93,13.37-2.29,0-4.39-1.53-4.2-4.97h-.19c-1.91,3.25-4.58,4.97-7.83,4.97s-6.11-2.67-6.11-7.07c0-6.88,5.54-13.37,13.37-13.37,2.48,0,4.58,.57,5.92,1.15l-1.91,10.12c-.76,4.2-.19,6.3,1.72,6.3,2.87,0,6.11-3.82,6.11-10.31,0-8.21-4.97-13.94-13.56-13.94-9.17,0-16.81,7.26-16.81,18.72,0,9.36,6.11,15.09,14.33,15.09,3.25,0,6.11-.76,8.4-1.91l.96,2.48Zm-3.25-24.26c-.57-.19-1.53-.38-2.87-.38-4.97,0-8.98,4.58-8.98,10.12,0,2.48,1.15,4.2,3.63,4.2,3.25,0,6.3-4.2,6.88-7.64l1.34-6.3Z"
      />
    </svg>
  );
}
export function SLSvgPhone({
  height = "125px"
}) {
  return (
    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 199 219" height={height}>
      <defs>
        <style>{".SLSvgPhone-1{fill:#1e4497;}"}</style>
      </defs>
      <path
        class="SLSvgPhone-1"
        d="M129.99,57.1h-41.59c-2.04,0-3.65,1.61-3.65,3.65v7.31h0v73.29c0,2.04,1.61,3.65,3.65,3.65h41.59c2.04,0,3.65-1.61,3.65-3.55V60.75c0-2.04-1.61-3.65-3.65-3.65Zm.97,84.35c0,.54-.43,.97-.97,.97h-41.59c-.54,0-.97-.43-.97-.97v-8.81h43.52v8.81ZM87.33,60.75c0-.54,.43-.97,.97-.97h41.59c.54,0,.97,.43,.97,.97v6.02h-43.52v-6.02Zm43.63,8.6v60.61h-43.63v-60.61h43.63Z"
      />
      <path
        class="SLSvgPhone-1"
        d="M103.98,138.87h10.42c.75,0,1.29-.54,1.29-1.29h0c0-.75-.64-1.29-1.29-1.29h-10.42c-.75,0-1.29,.54-1.29,1.29s.54,1.29,1.29,1.29Z"
      />
      <path
        class="SLSvgPhone-1"
        d="M95.39,113.52h27.62c.75,0,1.29-.54,1.29-1.29v-3.33h0c0-.75-.64-1.29-1.29-1.29h-27.62c-.75,0-1.29,.64-1.29,1.29v3.33h0c-.11,.75,.54,1.29,1.29,1.29Z"
      />
      <path
        class="SLSvgPhone-1"
        d="M95.39,95.57h27.62c.75,0,1.29-.64,1.29-1.29h0c0-.75-.64-1.29-1.29-1.29h-27.62c-.75,0-1.29,.64-1.29,1.29h0c-.11,.75,.54,1.29,1.29,1.29Z"
      />
      <path
        class="SLSvgPhone-1"
        d="M95.39,99.98h27.62c.75,0,1.29-.64,1.29-1.29h0c0-.75-.64-1.29-1.29-1.29h-27.62c-.75,0-1.29,.64-1.29,1.29h0c-.11,.75,.54,1.29,1.29,1.29Z"
      />
      <path
        class="SLSvgPhone-1"
        d="M95.39,91.16h27.62c.75,0,1.29-.64,1.29-1.29h0c0-.75-.64-1.29-1.29-1.29h-27.62c-.75,0-1.29,.64-1.29,1.29h0c-.11,.75,.54,1.29,1.29,1.29Z"
      />
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/editors/SLSvgWidget.jsx